import { render, staticRenderFns } from "./PageSeven.vue?vue&type=template&id=5ca81523&scoped=true"
import script from "./PageSeven.vue?vue&type=script&lang=js"
export * from "./PageSeven.vue?vue&type=script&lang=js"
import style0 from "./PageSeven.vue?vue&type=style&index=0&id=5ca81523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca81523",
  null
  
)

export default component.exports